<template>
  <div>
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        highlight-current-row
        :height="tableViewHeight">
        <el-table-column
          align="center"
          v-for="col in allColumns"
          :key="col.prop"
          :prop="col.prop"
          :label="col.label"
          :width="col.width">
          <template v-if="col.label === '序号'" v-slot:default="{ $index }">
            {{ (formData.pageNum - 1) * formData.pageSize + $index + 1 }}
          </template>
          <template v-else-if="col.label === '品牌名称'" v-slot="{row}">
            {{ row.brandId | filterBrandName(brands) }}
          </template>
        </el-table-column>
      </el-table>
      <summary-row v-if="showSummary" :summary-data="summaryData" :summary-params="queryParams"/>
      <el-pagination
        v-if="queryParams.statisticalType===2"
        style="margin-top: 15px; text-align: right"
        @size-change="handleSizeChange"
        @current-change="pageNoChange"
        :current-page="formData.pageNum"
        :page-sizes="pageSizes"
        :page-size="formData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
  </div>
</template>
<script>
import inspectionColumn from '@/views/InspectionManagement/inspectionColumn.js'
import SummaryRow from '@/views/InspectionManagement/components/summary-row.vue'
import Api from '@/api'
import { mapGetters } from 'vuex'
import { lookPDF } from '@/utils/tools'
export default {
  name: 'inspectionTable',
  components: {
    SummaryRow
  },
  props: {
    statisticalType: {
      type: Number,
      default: 1
    },
    // 接收父组件传递的查询条件
    queryParams: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tableLoading: true,
      // 完整列配置
      allColumns: [],
      tableData: [],
      tableViewHeight: 80,
      formData: {
        pageNum: 1,
        pageSize: 20
      },
      pageSizes: [10, 20, 50],
      total: 0,
      summaryData: {},
      showSummary: false
    }
  },
  watch: {
    // 监听 queryParams 变化（深监听，确保字段变化能触发）
    queryParams: {
      handler(newVal) {
        this.showSummary = false
        this.queryParams = newVal
        this.onSearch()
      },
      // 深度监听对象内部字段变化
      deep: true
    }
  },
  computed: {
    ...mapGetters([
      'brands'
    ])
  },
  filters: {
    filterBrandName(value, brands) {
      return brands.some(item => String(item.brandId) === String(value))
        ? brands.find(item => String(item.brandId) === String(value)).brandName
        : undefined
    }
  },
  created() {
    this.onSearch()
  },
  methods: {
    onSearch() {
      const type = this.queryParams.statisticalType
      this.getDynamicOrderKeys(type)
      this.tableLoading = true
      this.queryParams.currentPage = this.formData.pageNum
      this.queryParams.pageSize = this.formData.pageSize
      Api.getSumMiInspectionRecordsData(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.pageInfo.list
          this.total = res.data.pageInfo.total
          if (this.total > 0) {
            this.summaryData = {
              ...res.data.summary,
              ...(type === 1 ? { totalBrands: this.total } : { totalPerson: this.total })
            }
          } else {
            this.summaryData = {
              scanCheckNum: 0,
              compliantVehicleNum: 0,
              notCompliantVehicleNum: 0,
              registeredCount: 0,
              notRegisteredCount: 0,
              invalidCode: 0,
              ...(type === 1 ? { totalBrands: this.total } : { totalPerson: this.total })
            }
          }
          // 核查总数
          const scanCheckNum = this.summaryData.scanCheckNum
          // 未备案—未传数据
          const notRegisteredCount = this.summaryData.notRegisteredCount
          // 无效二维码
          const invalidCode = this.summaryData.invalidCode
          // 总超量投放率：未备案—未传数据/核查总数—无效二维码
          const overDeliveryRate = notRegisteredCount > 0 ? ((notRegisteredCount / (scanCheckNum - invalidCode)) * 100).toFixed(1) : 0
          this.$emit('summary-selected', {
            scanCheckNum: scanCheckNum,
            overDeliveryRate: overDeliveryRate
          })
          setTimeout(() => {
            this.showSummary = true
            this.tableLoading = false
          }, 300)
        } else {
          this.tableLoading = false
          this.showSummary = true
          this.$message.warning(res.message ? res.message : '操作异常，请联系管理员！')
        }
      }).catch(err => {
        this.tableLoading = false
        this.showSummary = true
        this.$message.warning('操作异常，请联系管理员！')
        console.log('扫一扫巡查统计数据异常：', err)
      })
      this.calcView()
    },
    pageNoChange(page) {
      this.formData.pageNum = page
      this.onSearch()
    },
    handleSizeChange(size) {
      this.formData.pageSize = size
      this.onSearch()
    },
    getDynamicOrderKeys(type) {
      const configTableName = this.getConfigMap(type, 'Table')
      // 通过映射关系获取配置名
      this.allColumns = inspectionColumn[configTableName].columns.map(item => ({
        prop: item.prop,
        label: item.label,
        width: item.width
      }))
    },
    // 统一配置映射方法
    getConfigMap(type, suffix) {
      if (type === 1) {
        // 企业类型
        return `brand${suffix}`
      } else {
        // 人名类型
        return `person${suffix}`
      }
    },
    // 巡查统计-导出功能
    handleInspectionExport(params) {
      const newParams = {
        selfAreaId: params.selfAreaId,
        statisticalType: params.statisticalType,
        inspectionStartTime: params.inspectionStartTime,
        inspectionEndTime: params.inspectionEndTime
      }
      Api.exportInspectionStatistics(newParams)
        .then(res => {
          if (res.code === 200) {
            lookPDF(res.data)
          } else {
            this.$message.warning(res.message)
          }
        })
    },
    calcView() {
      this.$nextTick(() => {
        let H = 0
        if (this.$refs.searchBox && this.$refs.searchBox.clientHeight) {
          H += Number(this.$refs.searchBox.clientHeight)
        }
        const type = this.queryParams.statisticalType
        if (type === 1) {
          this.tableViewHeight = window.innerHeight - H - 380
        } else {
          this.tableViewHeight = window.innerHeight - H - 420
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.layout-header {
  margin: 16px;
  width: calc(98% - 20px);
}
.demo-form-inline{
  margin-top: 24px;
}
.info-line {
  display: flex;
  align-items: center; /* 垂直居中 */
  margin-bottom: 15px; /* 每行之间的间距 */
  .label {
    min-width: 120px; /* 根据需要设置标签的最小宽度 */
    text-align: right; /* 标签文本右对齐（但冒号会保持在左边，因为冒号是标签的一部分） */
    padding-right: 15px; /* 标签和值之间的间距 */
    box-sizing: border-box; /* 确保padding不会增加元素的总宽度 */
  }
  .value {
    flex-grow: 1; /* 值占据剩余的空间 */
    word-break: break-all; /* 确保长文本不会溢出容器 */
  }
}
.summary-row {
  display: flex;
  align-items: center;
  gap: 24px; /* 控制项间距 */
  font-weight: bold;
  padding: 16px;
  background: #f8decd;
  border-radius: 4px;
  .summary-item {
    display: flex;
    align-items: center;
    font-size: 15px;
  }
  .label {
    min-width: 80px;
    color: #3c3e43;
  }
  .value {
    color: #202021;
  }
}
</style>
